import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IUserStore} from "data/stores/user/user.store";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable} from "mobx";

export interface IFooterController extends ViewController {
	get i18n(): ILocalizationStore;
	get isCountryUS(): boolean;
}

@injectable()
export class FooterController implements IFooterController {
	constructor(
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.UserStore) private _userStore: IUserStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get isCountryUS() {
		return this._userStore.isCountryUS;
	}
}
